<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records">
            <div class="row">
                <div class="col-12 mb-4 dan-connect">
                    <div class="bg-white border-radius-5 p-5">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center pt-3">
                                    <div class="col-md-6 text-center">
                                        <h2>Connect your DNA to see your genetic predispositions</h2>
                                        <i class="icon icon-dna"></i>
                                        <div class="General-Health px-4 py-4 mt-4 bg-body border-radius-10">
                                            <h3>General Health related genetic risks from DNA data include:</h3>
                                            <ul class="mb-0">
                                                <li class="d-flex justify-content-start align-items-center"><i class="icon icon-blood-pressure"></i> Hypertension and Cholestrol</li>
                                                <li class="d-flex justify-content-start align-items-center"><i class="icon icon-brain"></i> Mental Health</li>
                                                <li class="d-flex justify-content-start align-items-center"><i class="icon icon-blood-drop"></i> Diabetes</li>
                                                <li class="d-flex justify-content-start align-items-center"><i class="icon icon-plus"></i> 80+ more insights and reports</li>
                                            </ul>
                                        </div>
                                        <h4 class="mt-4 mb-3 text-left mb-0">I am tested with</h4>
                                        <div class="Gini-Health px-4 py-3 mb-5 bg-body border-radius-5 text-left mb-0">
                                            <p>Gini Health</p>
                                        </div>
                                        <router-link class="btn btn-blue dna-gini-button" to="/register-kit">Connect my DNA</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "connect-dna",
        data() {
            return {};
        },
        created(){
           this.pageName('Connect your DNA')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/connect-dna.vue